var _path, _g, _path2, _path3, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2005_3734",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 30,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00012207 3.05701H29.8296V30.0003H0.00012207V3.05701Z",
    className: "baseColor2Fill"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2005_3734)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4092 8.02024C28.4092 6.06172 26.8197 4.47507 24.8581 4.47507H4.97171C3.00989 4.47507 1.42058 6.06172 1.42058 8.02024V25.0371C1.42058 26.9953 3.00989 28.5822 4.97171 28.5822H24.8581C26.8197 28.5822 28.4092 26.9953 28.4092 25.0371V8.02024ZM29.8297 8.02024C29.8297 5.27918 27.6038 3.05701 24.8581 3.05701H4.97171C2.2258 3.05701 0.00012207 5.27918 0.00012207 8.02024V25.037C0.00012207 27.7781 2.2258 30.0003 4.97171 30.0003H24.8581C27.6038 30.0003 29.8297 27.7781 29.8297 25.037V8.02024Z",
    className: "color2Fill"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 6.30024C7 6.68664 7.22384 7.00024 7.5 7.00024C7.776 7.00024 8 6.68664 8 6.30024V0.700244C8 0.31362 7.776 0.000244141 7.5 0.000244141C7.22384 0.000244141 7 0.31362 7 0.700244V6.30024Z",
    className: "color2Fill"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2005_3734",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 31
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 30.0002H30V0.000244141H0V30.0002Z",
    className: "baseColor2Fill"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2005_3734)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 13.0002H29V12.0002H1V13.0002Z",
    className: "color2Fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 0.700244V6.30024C22 6.68664 22.2238 7.00024 22.5 7.00024C22.776 7.00024 23 6.68664 23 6.30024V0.700244C23 0.31362 22.776 0.000244141 22.5 0.000244141C22.2238 0.000244141 22 0.31362 22 0.700244Z",
    className: "color2Fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 16.0002C6.672 16.0002 6 16.6722 6 17.5002C6 18.3282 6.672 19.0002 7.5 19.0002C8.32776 19.0002 9 18.3282 9 17.5002C9 16.6722 8.32776 16.0002 7.5 16.0002Z",
    className: "color2Fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 16.0002C13.672 16.0002 13 16.6722 13 17.5002C13 18.3282 13.672 19.0002 14.5 19.0002C15.3278 19.0002 16 18.3282 16 17.5002C16 16.6722 15.3278 16.0002 14.5 16.0002Z",
    className: "color2Fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 16.0002C21.672 16.0002 21 16.6722 21 17.5002C21 18.3282 21.672 19.0002 22.5 19.0002C23.3278 19.0002 24 18.3282 24 17.5002C24 16.6722 23.3278 16.0002 22.5 16.0002Z",
    className: "color2Fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 23.0002C21.672 23.0002 21 23.6722 21 24.5002C21 25.3282 21.672 26.0002 22.5 26.0002C23.3278 26.0002 24 25.3282 24 24.5002C24 23.6722 23.3278 23.0002 22.5 23.0002Z",
    className: "color2Fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 23.0002C13.672 23.0002 13 23.6722 13 24.5002C13 25.3282 13.672 26.0002 14.5 26.0002C15.3278 26.0002 16 25.3282 16 24.5002C16 23.6722 15.3278 23.0002 14.5 23.0002Z",
    className: "color2Fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 24.5002C6 25.3282 6.672 26.0002 7.5 26.0002C8.32776 26.0002 9 25.3282 9 24.5002C9 23.6722 8.32776 23.0002 7.5 23.0002C6.672 23.0002 6 23.6722 6 24.5002Z",
    className: "color2Fill"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/iconCalendar.65fee0fd91c311ffcb7d50ac2b61b180.svg";
export { ForwardRef as ReactComponent };